@if (!compact) {
  <div
    class="o-step-indicator__header o-step-indicator__header--wide"
    role="tablist"
    >
    <tg-scrollable-container horizontal>
      <div class="o-step-indicator__header-content">
        @for (item of items; track item.id) {
          <tm-step-indicator-tab [item]="item">
          </tm-step-indicator-tab>
        }
      </div>
    </tg-scrollable-container>
  </div>
}
@if (compact) {
  <tg-rack>
    <tg-rack-item
      class="o-step-indicator__header o-step-indicator__header--compact"
      [class.o-step-indicator__header--disable-step-titles]="!showTitles"
      center
      >
      <tg-rack-item-prefix>
        @if (prevItem) {
          <button
            class="o-step-indicator__button o-step-indicator__button--prev"
            tgButton2
            transparent
            [disabled]="prevItem.disabled"
            (click)="moveBack()"
            >
            <span class="o-step-indicator__button-flex">
              <span class="o-step-indicator__button-icon">
                <tg-icon-left
                  alt="Go back"
                  name="basic-arrow-left"
                  size="small"
                  >
                </tg-icon-left>
              </span>
              <span class="h-visually-hidden"> Go to previous step </span>
              <span
                class="o-step-indicator__button-text"
                        [ngClass]="{
                            'h-visually-hidden': !showTitles
                        }"
                >
                {{ prevItem.title }}
              </span>
            </span>
          </button>
        }
      </tg-rack-item-prefix>
      <tg-rack-item-primary>
        <tg-dropdown class="o-step-indicator__dropdown" closeOnClick>
          <button
            tgButton2
            transparent
            tgDropdownTrigger
            class="o-step-indicator__dropdown-trigger"
            >
            <span class="h-visually-hidden"> The current step is </span>
            <div class="o-step-indicator__step-counter">
              Step {{ currentStepNumber }} of {{ items.length }}
            </div>
            <tm-step-indicator-step-info [item]="selectedItem">
            </tm-step-indicator-step-info>
          </button>
          <tg-dropdown-content class="o-step-indicator__dropdown-content">
            <tg-rack bleed ruled role="tablist">
              @for (item of items; track item.id) {
                <tm-step-indicator-step-button
                  [item]="item"
                  >
                </tm-step-indicator-step-button>
              }
            </tg-rack>
          </tg-dropdown-content>
        </tg-dropdown>
      </tg-rack-item-primary>
      <tg-rack-item-suffix>
        @if (nextItem) {
          <button
            class="o-step-indicator__button o-step-indicator__button--next"
            tgButton2
            transparent
            [disabled]="nextItem.disabled"
            (click)="moveForward()"
            >
            <span class="o-step-indicator__button-flex">
              <span class="h-visually-hidden"> Go to next step </span>
              <span
                class="o-step-indicator__button-text"
                        [ngClass]="{
                            'h-visually-hidden': !showTitles
                        }"
                >
                {{ nextItem.title }}
              </span>
              <span class="o-step-indicator__button-icon">
                <tg-icon-right
                  alt="Go forward"
                  name="basic-arrow-right"
                  size="small"
                  >
                </tg-icon-right>
              </span>
            </span>
          </button>
        }
      </tg-rack-item-suffix>
    </tg-rack-item>
  </tg-rack>
}
<ng-container *ngTemplateOutlet="selectedItem?.content"> </ng-container>
